<template>
  <div>
    <LoadingWidget v-if="loading" />

    <template v-else>
      <v-sheet class="py-6 py-md-8 px-3" color="primary">
        <TitleWidget :small="xsOnly" dark>
          {{ title }}
        </TitleWidget>
      </v-sheet>

      <v-container class="pt-6 pt-md-8 pb-10 pb-md-13 pb-lg-16">
        <div
          class="
            grey--text
            text-h5 text-md-h4 text-center
            font-weight-medium
            mb-2 mb-md-4
          "
        >
          {{ item.title }}
        </div>

        <div class="grey--text text-body-2 font-weight-regular mb-4 mb-md-6">
          {{
            formatDate(item.date, {
              year: "numeric",
              month: "long",
              day: "numeric",
            })
          }}
        </div>

        <img
          v-if="image && item.text"
          class="d-block mb-6 item-img"
          :src="files + image + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
          :alt="title"
          width="100%"
        />

        <div
          v-if="item.text"
          class="grey--text text-body-1 font-weight-regular ck-content"
          v-html="item.text"
        ></div>

        <GallerySection
          v-if="gallery.length > 1"
          :has-title="!!item.text"
          :items="gallery"
        />
      </v-container>
    </template>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import GallerySection from "../components/sections/GallerySection.vue";
import { formatDate } from "../utils/formatDate";

const _config = {
  mod: "articles",
};

const _data = {
  title: "Notícias",
  loading: true,
  noContentText: "Nenhum conteúdo adicionado até o momento, volte mais tarde.",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    item() {
      return this.$rest(_config.mod).item;
    },
    image() {
      return this.item?.img?.featured?.path || "";
    },
    gallery() {
      if (this.item?.img?.list.length)
        return this.item.img.list.map(({ path, title }) => ({
          src: this.files + path,
          caption: title,
        }));

      return [];
    },
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    formatDate,
    getItem() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getItem();
    },
    item() {
      document.title = `${this.title} | ${this.name}`;
    },
  },
  created() {
    this.getItem();
  },
  components: {
    LoadingWidget,
    TitleWidget,
    GallerySection,
  },
};
</script>

<style lang="scss" scoped>
.item-img {
  max-height: 60vh;
  max-width: 100%;
  object-fit: contain;
}
</style>
